/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ExternalDimensioningResultFragment = {
  __typename: "ExternalDimensioningResult"
  transactionId: string
  environmentalVars?: Array<any> | null
  variantKeyData?: any
  dllVersion?: string | null
  language?: string | null
  technicalData?: Array<
    | {
        __typename: "ExternalDimensioningTechnicalDataDllVersion"
        dllVersion: string
      }
    | {
        __typename: "ExternalDimensioningTechnicalDataTable"
        header?: Array<string> | null
        content?: any
        summary?: string | null
        type?: string | null
      }
  > | null
  technicalInput?: Array<{
    __typename: "ExternalDimensioningTechnicalInput"
    name: string
    label?: string | null
    unit?: string | null
    value?: any
    userSelected: boolean
  }> | null
  supplementaryText?: Array<{
    __typename: "ExternalDimensioningSupplementaryText"
    text: string
  }> | null
  transferData?: {
    __typename: "ExternalDimensioningTransferData"
    origin?: string | null
  } | null
}

export type ExternalDimensioningConfigurationFragment = {
  __typename: "ExternalDimensioningConfiguration"
  id: string
  variantKey: string
  dimensioningKey: string
  productType: string
  accessories: Array<string>
  errors?: Array<{
    __typename: "APIError"
    code: string
    message?: string | null
    cause?: any
  }> | null
}

export const ExternalDimensioningResultFragmentDoc = gql`
  fragment ExternalDimensioningResult on ExternalDimensioningResult {
    transactionId
    environmentalVars
    technicalData {
      ... on ExternalDimensioningTechnicalDataTable {
        header
        content
        summary
        type
      }
      ... on ExternalDimensioningTechnicalDataDllVersion {
        dllVersion
      }
    }
    technicalInput @type(name: "ExternalDimensioningTechnicalInput") {
      name
      label
      unit
      value
      userSelected
    }
    variantKeyData
    supplementaryText @type(name: "ExternalDimensioningSupplementaryText") {
      text
    }
    dllVersion
    language
    transferData @type(name: "ExternalDimensioningTransferData") {
      origin
    }
  }
`
export const ExternalDimensioningConfigurationFragmentDoc = gql`
  fragment ExternalDimensioningConfiguration on ExternalDimensioningConfiguration {
    id
    variantKey
    dimensioningKey
    productType
    errors @type(name: "APIError") {
      code
      message
      cause
    }
    accessories
  }
`
